module.exports = __webpack_public_path__ + "static/media/teachstream_logo@2x.8ed550a1.png";